module.exports = __webpack_public_path__ + "static/media/moon.fdd91b4f.png";